var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOffercat3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 56,
    viewBox: "0 0 42 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.2344 11.4844L30.5266 0.765625C30.0344 0.273438 29.3672 0 28.6672 0H28V14H42V13.3328C42 12.6438 41.7266 11.9766 41.2344 11.4844ZM24.5 14.875V0H2.625C1.17031 0 0 1.17031 0 2.625V53.375C0 54.8297 1.17031 56 2.625 56H39.375C40.8297 56 42 54.8297 42 53.375V17.5H27.125C25.6812 17.5 24.5 16.3188 24.5 14.875ZM31.5 32.375V37.625C31.5 38.1063 31.1063 38.5 30.625 38.5H24.5V44.625C24.5 45.1063 24.1063 45.5 23.625 45.5H18.375C17.8937 45.5 17.5 45.1063 17.5 44.625V38.5H11.375C10.8938 38.5 10.5 38.1063 10.5 37.625V32.375C10.5 31.8937 10.8938 31.5 11.375 31.5H17.5V25.375C17.5 24.8937 17.8937 24.5 18.375 24.5H23.625C24.1063 24.5 24.5 24.8937 24.5 25.375V31.5H30.625C31.1063 31.5 31.5 31.8937 31.5 32.375Z",
    fill: "#CB202D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffercat3);
export default __webpack_public_path__ + "static/media/offercat3.67f2b440ec6128187e5480cc17949f25.svg";
export { ForwardRef as ReactComponent };